import React, {useState} from 'react'
import { medsCreateState, createMedsStep } from 'store/storeValtio';

export default function MedicationOften({prevStep, nextStep}) {
  const [oftenNames, setOftenNames] = useState([]);

    function selectOften(n) {
      //console.log('selectOften', n);
      // reset the schedule 
      medsCreateState.schedule = [];
      medsCreateState.often = n.often;
      medsCreateState.occurance = n.count;

      nextStep(n.nextStep);
    }

    const oftenList = [
      { 'descr': 'Hourly', 'count': 0, 'often': 'hourly', 'nextStep': createMedsStep.hourly },
      { 'descr': 'EveryDay', 'count': 0, 'often': 'daily', 'nextStep': createMedsStep.daily },
      { 'descr': 'Every ? Days', 'count': 0, 'often': 'everyndays', 'nextStep': createMedsStep.everyndays },
      { 'descr': 'Weekly', 'count': 0, 'often': 'weekly', 'nextStep': createMedsStep.weekly },
      { 'descr': 'Other', 'count': 1, 'often': 'other', 'nextStep': createMedsStep.confirm },
      { 'descr': 'As needed', 'count': 1, 'often': 'asNeeded', 'nextStep': createMedsStep.confirm },
    ];

    const li = 'py-1';
    return (
      <>
        <div className='medBody text-center'>
          <b>How often</b> do you take your medication?
        </div>
        <div className='medList'>
          {oftenList.map((o,ix) => {
            const li = o.often === medsCreateState.often ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
            return (
              <div
                key={ix} 
                className={'medCard ' + li} 
                onClick={()=>selectOften(o)} 
                id={o.code}>
                  {o.descr}
                </div>
              )
            })
          }
        </div>
      </>
      );
    }
